import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Typography, Divider, Stack, Box } from '@mui/material';
import Button from 'components/Common/CustomButton';
import Modal from 'components/Common/Modal';
import { AppDispatch } from 'redux/store';
import routes from 'constants/routes';
import CreateStaffForm from 'components/Staff/CreateStaffForm';
import { CreateStaff } from 'types/staff';
import CardWrapper from 'components/Common/CardWrapper';
import { createStaff } from 'redux/slices/staff/staffSlice';

export default function CreateNewStaff() {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSendInvitation = async (formValues: CreateStaff) => {
        try {
            setLoading(true);
            const res: any = await dispatch(createStaff({ formValues }));
            setLoading(false);
            if (res?.payload?.code === 200) {
                setModalOpen(true);
            }
        } catch (error) {
            setLoading(false);
            throw error;
        }
    };
    const handleInvitationSuccess = () => {
        setModalOpen(false);
        navigate(routes.staff.main);
    };
    return (
        <CardWrapper>
            <Stack>
                <Typography sx={{ fontSize: { xs: 16, sm: 24 }, mb: 2, color: '#220E40', fontWeight: 400 }} variant="h1">
                    Invite New Employee
                </Typography>
                <Divider sx={{ borderBottomWidth: 2 }} />
                <Typography sx={{ mt: 2, mb: 4, fontSize: 14 }} variant="body1">
                    Please fill in the information for the new staff member and we will send an email invitation to them. They will then
                    create a password and gain access to this portal. Their access level will be determined by the level you set here. You
                    may adjust this in the future.
                </Typography>
            </Stack>
            <Box mb={10}>
                <CreateStaffForm onSubmit={handleSendInvitation} loading={loading} />
            </Box>
            <Modal onClose={() => setModalOpen(false)} isOpen={modalOpen}>
                <>
                    <Typography fontSize={'22px'} fontWeight={600}>
                        New Employee
                    </Typography>
                    <Typography sx={{ fontSize: 18, my: 2 }}>We have sent a temporary password to the email provided.</Typography>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 32 }}>
                        <Button onClick={handleInvitationSuccess} width={152} title="Done" />
                    </div>
                </>
            </Modal>
        </CardWrapper>
    );
}
